import { APITypesV1 } from "@cur8/api-client";
import { makeStyles } from "@material-ui/styles";
import { useAnnotationImage } from "render/hooks/useAnnotationImage";

const useStyles = makeStyles({
  ZoomedImage: {
    width: "95vw",
    maxWidth: "95%",
    margin: "6px",
  },
  DermaFlex: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  ImageContainer: {
    display: "flex",
    margin: "4px",
    alignItems: "flex-end",
  },
  Timestamp: {
    fontSize: "12px",
  },
});

interface ZoomedCanvasImageProps {
  anno: APITypesV1.Annotation;
}

export function ZoomedCanvasImage({ anno }: ZoomedCanvasImageProps) {
  const classes = useStyles();
  // isOverview=false will fetch the zoomed/cropped version
  const { image } = useAnnotationImage(anno, false);

  function parseTimestamp(anno: APITypesV1.Annotation) {
    return (
      anno.targetUri.split(":")[3]?.split(".")[0] ||
      anno.createdAt.split("T")[0]
    );
  }

  if (!image) {
    return (
      <div>
        <p>loading ...</p>
      </div>
    );
  }

  return (
    <div className={classes.ImageContainer}>
      <div className={classes.DermaFlex}>
        <img className={classes.ZoomedImage} src={image.src} alt="" />
        <div className={classes.Timestamp}>{parseTimestamp(anno)}</div>
      </div>
    </div>
  );
}
